import classNames from "classnames";
import React from "react";
import { TooltipComponent } from "@fidget/common/components/tooltipComponent";
import styles from "./editMeLabel.css";

interface Props {
  value?: string;
  fakeValue?: string;
  onClick?: () => void;
  placeholder?: string;
  className?: string;
}

interface State {
  overflown: boolean;
}

/**
 * Displays area with appropriately styled value, fake (temp) value or placeholder
 * and edit icon on hover. If the displayed value exceeds available space,
 * shows tooltip with an entire value on hover.
 */
export class EditMeLabel extends React.Component<Props, State> {
  valueSpan?: HTMLSpanElement;

  constructor(props: Props) {
    super(props);
    this.state = { overflown: false };
  }

  componentDidMount() {
    this.checkOverflow();
  }

  componentDidUpdate() {
    this.checkOverflow();
  }

  /**
   * Check if element containing the value overflows and set state accordingly.
   */
  checkOverflow = () => {
    const el = this.valueSpan;
    const overflown = (el && el.offsetWidth < el.scrollWidth) || false;
    if (overflown !== this.state.overflown) {
      this.setState({ overflown });
    }
  };

  render() {
    const { value, fakeValue, placeholder, onClick, className } = this.props;
    const displayedValue = value || fakeValue;
    const canShowTooltip = !!displayedValue;
    return (
      <TooltipComponent
        text={displayedValue}
        positionPreset={"top"}
        tooltipShow={canShowTooltip && this.state.overflown}
        breakWords
      >
        <div
          className={classNames(styles.editme, className || [])}
          onClick={onClick && ((ev: React.MouseEvent<HTMLDivElement>) => onClick())}
        >
          <span
            ref={(el) => {
              this.valueSpan = el as HTMLSpanElement;
            }}
            className={classNames(styles.value, {
              [styles.fake]: displayedValue && !value,
              [styles.placeholder]: !displayedValue && placeholder
            })}
          >
            {displayedValue || placeholder || ""}
          </span>
          <i className={classNames(styles.icon, "icon-pencil")} />
        </div>
      </TooltipComponent>
    );
  }
}
